
import { Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import { getMenuList } from '../service-link-img/actions';

import './header-menu.scss';

const KGD_INFO_URL = 'https://www.gov.kz/org/kgd?lang=ru';

const KGD_INFO_TITLES = {
    ru: 'Информационный раздел КГД',
    kk: 'МКК ақпараттық бөлімі',
    en: 'SRC Information Section',
};

const HeaderMenu = (props) => {
    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        getMenuList(props.context).then((value) => {
            if (value.data) {
                setMenuItems(value.data);
            }
        });
    }, [props.context]);

    const language = String(props.language || 'ru')
        .toLowerCase()
        .split(/[-_]/)[0];

    const title =
        KGD_INFO_TITLES[language] || KGD_INFO_TITLES.ru;

    const goTo = (path: string) => {
        window.open(
            '/' + props.language +
            path.replace('/isna-portal-cms', ''),
            '_self'
        );
    };

    const items = menuItems
        .filter((x) => !x.dataAsJson?.menu)
        .map((x) => ({
            key: x.id,
            className: 'menu-link',
            onClick: () => goTo(x._path),
            label: x.displayName,
        }));

    const externalItem = {
        key: 'kgd-info-section',
        className: 'menu-link',
        onClick: () => {
            window.open(KGD_INFO_URL, '_blank', 'noopener,noreferrer');
        },
        label: title,
    };

    const knowledgeBaseIndex = menuItems
        .filter((x) => !x.dataAsJson?.menu)
        .findIndex((item) =>
            item._path?.endsWith('/knowledge-base')
        );
    if (knowledgeBaseIndex !== -1) {
        items.splice(knowledgeBaseIndex + 1, 0, externalItem);
    } else {
        items.push(externalItem);
    }

    return (
        <Menu
            mode="horizontal"
            className="header-menu"
            items={items}
        />
    );
};

export default HeaderMenu;
